import React from 'react';
import PropTypes from 'prop-types';
import { PageTitle } from 'src/components/Page';
import Styled from './Popup.styles';

const PopupSection = ({ children, title }) => {
  return (
    <Styled.Section>
      <PageTitle>{title}</PageTitle>

      {children}
    </Styled.Section>
  );
};

PopupSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
};

PopupSection.defaultProps = {};

export default React.memo(PopupSection);
